import script from "./memberSelectorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./memberSelectorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./memberSelectorDialog.vue?vue&type=style&index=0&id=0ce1c24e&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce1c24e"]])

export default __exports__